import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
import { Button } from "reactstrap";

export const ExcelLink = ({ data, label='descargar', filename = "data.xlsx", class_name="btn btn-link" }) => {
   const handleDownload = () => {
   const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a New Workbook and Append the Worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Write the Workbook to Binary String
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Save the File
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, filename);
  };

  return <Button className={class_name} onClick={handleDownload}><small>{label} &darr;</small></Button>;
};
